import gql from "graphql-tag";

export const ClientById = gql`
  query Client($id: String!, $token: String!) {
    ClientById(id: $id, token: $token) {
      id
      scd_name
      scd_surname
      scd_email
      scd_pp_path
      scd_saID
      scd_cellNumber
      scd_dateOfBirth
      scd_title
      scd_occupation
      scd_residentialAddress
      scd_monthlyIncome
      scd_smoker
      scd_maritalStatus
      scd_qualification
      scd_selfEmployed
      scd_salaryType
      scd_taxDispensation
      scd_spouseIncome
      scd_pAdmin
      scd_pTravel
      scd_pManual
      scd_pSupervision
      scd_gender
      scd_calculatedMonthlyIncomeAT
      scd_actualMonthlyIncomeAT
      scd_clientFileNumber
      scd_clientType
      scd_correspondenceType
      scd_correspondenceLanguage
      scd_correspondenceFormality
      scd_nickName
      scd_secondAndOtherNames
      scd_initials
      scd_idType
      scd_passportNumber
      scd_countryOfIssue
      scd_maidenName
      scd_weddingDate
      scd_howMarried
      scd_incomeTaxNumber
      scd_TelNumberHome
      scd_TelNumberWork
      scd_qualificationName
      scd_height
      scd_weight
      scd_currentGp
      scd_currentGpYears
      scd_currentDentist
      scd_hasWill
      scd_willExecutor
      scd_wilLocation
      sb_accountName
      sb_bank
      sb_branchName
      sb_branch
      sb_accountNumber
      sb_accountType
      scd_residentialAddress2
      scd_residentialAddress3
      scd_residentialAddress4
      scd_postalCode
      scd_postalAddress1
      scd_postalAddress2
      scd_postalAddress3
      scd_postalAddress4
      scd_postalAddressCode
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/clientById.js